













































































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { getStore } from '../store';
import { useRouter } from '../router';
import { usePlatformChecker } from '../platform-checker';

const componentName = 'PasswordRecovery';

export default defineComponent({
    name: componentName,
    
    setup(context) {
        const store = getStore(), { router, route } = useRouter(), platform = usePlatformChecker();

        const state = reactive({
            form: {
                email: ''
            },
            passwordRecoverySent: false,
            passwordRecoveryError: false,
            passwordRecoveryProgress: false
        });

        const onPasswordRecoveryClick = async () => {
            state.passwordRecoveryError = false;
            state.passwordRecoveryProgress = true;

            const clientId = route.value.query.client_id;
            const returnUrl = route.value.query.returnUrl;
            let res = await store.dispatch('passwordSendUpdateEmail', {
                email: state.form.email,
                clientId: clientId,
                language: route.value.query.language || 'en',
                returnUrl: returnUrl,
                platform: platform.getPlatform.value
            });

            state.passwordRecoveryProgress = false;

            if (res && res.result == 'OK') {
                state.passwordRecoverySent = true;
            }
            else {
                state.passwordRecoveryError = true;
            }
        }

        const signinRoute = computed(() => {
            return { name: 'access-signin', query: route.value.query };
        });

        return {
            state,
            onPasswordRecoveryClick,
            signinRoute
        }
    }
})
